<template>
  <div class="container">
    <loading-wrap :loading="loading">
      <div class="row justify-content-center pt-5">
        <div class="col-8">
          <h4>{{ form._id ? "Edit" : "Create" }} Assessment</h4>
          <div class="alert alert-danger" v-if="error">{{ error }}</div>
          <form @submit.prevent="submit">
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label>Student First Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Student First Name"
                    required
                    v-model="form.firstName"
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>Student Last Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Student Last Name"
                    required
                    v-model="form.lastName"
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>Student Gender</label>
                  <v-select
                    v-model="form.gender"
                    :clearable="false"
                    :options="['male', 'female']"
                    label="name"
                  >
                    <template slot="selected-option" slot-scope="option">
                      <span style="text-transform: capitalize">{{
                        option.name
                      }}</span>
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-flex">
                        <span style="text-transform: capitalize">{{
                          option.name
                        }}</span>
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label>Tutor First Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Tutor First Name"
                    required
                    v-model="form.tutorFirstName"
                  />
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label>Tutor Last Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Tutor Last Name"
                    required
                    v-model="form.tutorLastName"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label>Tutor Email</label>
                  <input
                    type="email"
                    class="form-control"
                    placeholder="Tutor Email"
                    required
                    v-model="form.tutorEmail"
                  />
                </div>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label>Date of Assessment</label>

                  <date-picker
                    v-model="form.dateOfAssessment"
                    :config="options"
                  ></date-picker>
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>
                    Year Level
                    <help-tip title="Prep = 0" />
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    min="0"
                    step="1"
                    max="7"
                    placeholder="Year Level"
                    required
                    v-model="form.yearLevel"
                  />
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>Location</label>
                  <v-select
                    v-model="form.location"
                    :clearable="false"
                    :options="['Paddington', 'Cannon Hill', 'Mt Gravatt']"
                    label="name"
                  >
                    <template slot="selected-option" slot-scope="option">
                      <span style="text-transform: capitalize">{{
                        option.name
                      }}</span>
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-flex">
                        <span style="text-transform: capitalize">{{
                          option.name
                        }}</span>
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
              <div class="col-6" v-if="this.form._id">
                <div class="form-group">
                  <label>Subject</label>
                  <v-select
                    v-model="form.subject"
                    :clearable="false"
                    :options="subjectOptions"
                    label="name"
                  >
                    <template slot="selected-option" slot-scope="option">
                      <span style="text-transform: capitalize">{{
                        option.name
                      }}</span>
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-flex">
                        <span style="text-transform: capitalize">{{
                          option.name
                        }}</span>
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <div class="row" v-if="!this.form._id">
              <div class="col-4">
                <div class="form-group">
                  <label>Subject</label>
                  <div
                    v-for="(selectedSubject, index) in selectedSubjects"
                    :key="index"
                  >
                    <v-select
                      v-model="subjects[index]"
                      :clearable="false"
                      :options="subjectOptions"
                      label="name"
                    >
                      <template slot="selected-option" slot-scope="option">
                        <span style="text-transform: capitalize">{{
                          option.name
                        }}</span>
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-flex">
                          <span style="text-transform: capitalize">{{
                            option.name
                          }}</span>
                        </div>
                      </template>
                    </v-select>
                    <br />
                    <div class="form-group mt-2">
                      <label>Completed Assessment (PDF)</label>
                      <input
                        type="file"
                        @change="upload($event, index, 'assessment')"
                        :ref="'notesFile' + index"
                        name="file"
                        accept="*"
                        class="form-control-file"
                      />
                      <span v-if="getAttachmentName(index, 'assessment')">
                        {{ getAttachmentName(index, "assessment") }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-8">
                <label>Template</label>
                <div
                  v-for="(selectedSubject, index) in selectedSubjects"
                  :key="index"
                >
                  <v-select
                    v-model="templates[index]"
                    :clearable="false"
                    :options="templateOptions"
                    label="name"
                  >
                    <template slot="selected-option" slot-scope="option">
                      <span style="text-transform: capitalize">{{
                        option.name
                      }}</span>
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-flex">
                        <span style="text-transform: capitalize"
                          >{{ option.name }}, Grade: {{ option.yearLevel }},
                          Subject: {{ option.subject }}</span
                        >
                      </div>
                    </template>
                  </v-select>
                  <br />
                  <div class="form-group mt-2">
                    <label>Completed Notes (PDF)</label>
                    <input
                      type="file"
                      @change="upload($event, index, 'notes')"
                      :ref="'notesFile' + index"
                      name="file"
                      accept="*"
                      class="form-control-file"
                    />
                    <span v-if="getAttachmentName(index, 'notes')">
                      {{ getAttachmentName(index, "notes") }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <br />

            <div class="form-group" v-if="!this.form._id">
              <b-button-toolbar>
                <b-button-group class="mx-1">
                  <button
                    v-show="
                      this.selectedSubjects.length < this.subjectOptions.length
                    "
                    @click="addSubject"
                    type="button"
                    class="btn btn-primary"
                  >
                    Add Subject
                  </button>
                </b-button-group>
                <b-button-group class="mx-1">
                  <button
                    v-show="this.selectedSubjects.length > 1"
                    @click="removeSubject"
                    type="button"
                    class="btn btn-danger"
                  >
                    Remove Subject
                  </button>
                </b-button-group>
              </b-button-toolbar>
            </div>
            <hr />
            <div class="text-right pb-2">
              <button
                type="submit"
                class="btn btn-success btn-lg"
                :disabled="formLoading"
              >
                <svg-loader />
                <span>Submit</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </loading-wrap>
  </div>
</template>

<script>
// Import this component
import datePicker from "vue-bootstrap-datetimepicker";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";

export default {
  components: {
    datePicker,
  },
  data() {
    return {
      error: "",
      templates: [],
      subjects: [],
      subjectOptions: ["english", "maths"],
      templateOptions: [],
      categorys: [],
      selectedSubjects: [0],
      assessment: [],
      loading: true,
      formLoading: false,
      fileUploading: false,
      template: null,
      options: {
        format: "DD/MM/YYYY",
        useCurrent: false,
      },
      form: {
        firstName: "",
        lastName: "",
        tutorFirstName: "",
        tutorLastName: "",
        tutorEmail: "",
        dateOfAssessment: "",
        yearLevel: null,
        subject: null,
        questions: [],
        assessmentText: "",
        location: "",
        attachments: [],
      },
    };
  },
  created() {
    this.axios
      .get(`${process.env.VUE_APP_API_URL}/api/categorys`)
      .then((res) => {
        this.categorys = res.data;
      });

    const { id } = this.$route.query;
    if (id) {
      this.axios
        .get(`${process.env.VUE_APP_API_URL}/api/assessments/${id}`)
        .then((res) => {
          this.form = res.data;
          this.loading = false;
        });
    } else {
      this.axios
        .get(`${process.env.VUE_APP_API_URL}/api/templates`)
        .then((res) => {
          this.templateOptions = res.data;
          this.loading = false;
        });
    }
  },
  methods: {
    addSubject() {
      this.selectedSubjects.push(0);
    },

    removeSubject() {
      this.selectedSubjects.pop();
    },

    submit() {
      this.error = null;
      var newForms = [];

      if (this.form._id) {
        if (!this.form.gender || !this.form.subject) {
          return (this.error = "Please complete all required fields.");
        }
      } else {
        if (
          this.hasDuplicates(this.subjects) ||
          this.hasDuplicates(this.templates)
        ) {
          return (this.error = "Cannot choose same subjects or templates.");
        } else if (
          !this.form.gender ||
          this.subjects.length != this.selectedSubjects.length ||
          this.templates.length != this.selectedSubjects.length
        ) {
          return (this.error = "Please complete all required fields.");
        }
        for (var i = 0; i < this.selectedSubjects.length; i++) {
          var newForm = {
            ...this.form,
            subject: this.subjects[i],
            questions: this.templates[i].questions,
            assessmentText: this.templates[i].assessmentText,
          };
          newForms.push(newForm);
        }
      }

      this.formLoading = true;

      // Config for the axios request
      const mode = this.form._id ? "patch" : "post";
      const URL = this.form._id
        ? `${process.env.VUE_APP_API_URL}/api/assessments/${this.form._id}`
        : `${process.env.VUE_APP_API_URL}/api/assessments`;

      // Send JSON for PATCH
      // Send FormData for POST
      const data = this.form._id ? this.form : newForms;

      // Use the config to decide which type of request Editing or creating
      this.axios[mode](URL, data)
        .then((res) => {
          const message =
            mode === "patch"
              ? "Assessment successfully edited."
              : "New assessment successfully added.";

          this.$root.$emit("popup", message);
          this.$router.push("/dashboard/assessments");
        })
        .catch((res) => {
          this.error =
            "Interal server error. You may have forgotten to fill out a required field.";
        })
        .finally(() => (this.formLoading = false));
    },
    upload(event, index, type) {
      // Get the selected file (only one file expected here)
      const file = event.target.files[0];
      if (!file) return;

      // Prepare new filename parts
      const firstName = this.form.firstName.trim().replace(/\s+/g, "_");
      const lastName = this.form.lastName.trim().replace(/\s+/g, "_");
      const subject = (this.subjects[index] || "")
        .trim()
        .split(/\s+/)
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join("-");
      // Construct new filename
      const fileType =
        type.charAt(0).toUpperCase() + type.slice(1);

      const newFileName = `${firstName}-${lastName}-${subject}-${fileType}`;

      // Rename file using File constructor
      const renamedFile = new File([file], newFileName, {
        type: file.type,
        lastModified: file.lastModified,
      });

      // Prepare FormData for upload
      const formData = new FormData();
      formData.append("file", renamedFile);

      // Optionally, show uploading spinner
      this.fileUploading = true;

      // Axios config (let browser set boundary for multipart)
      const config = {
        headers: {
          "Content-Type": undefined,
        },
      };

      // Upload file to server
      this.axios
        .post(
          `${process.env.VUE_APP_API_URL}/api/templates/uploads`,
          formData,
          config
        )
        .then((res) => {
          this.form.attachments = this.form.attachments.filter(
            (a) => !(a.subject === subject && a.type === type)
          );

          // Add new attachment info
          this.form.attachments.push({
            subject,
            type, // 'notes' or 'assessment'
            file: res.data, // API returned info (like filename, url, etc)
          });
        })
        .catch(() => {
          this.$root.$emit("popup", "Failed to upload file.");
        })
        .finally(() => {
          this.fileUploading = false;
          // Clear the input so you can upload again if needed
          const refName =
            type === "assessment"
              ? `assessmentFile${index}`
              : `notesFile${index}`;
          if (this.$refs[refName]) {
            this.$refs[refName].value = null;
          }
        });
    },
    onAssessmentChange(event, index) {
      this.upload(event, index, "assessment");
    },
    onNotesChange(event, index) {
      this.upload(event, index, "notes");
    },
    hasDuplicates(array) {
      return new Set(array).size !== array.length;
    },
    getAttachmentName(index, type) {
      const subject = (this.subjects[index] || "")
        .trim()
        .split(/\s+/)
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join("-");

      const attachments = Array.isArray(this.form.attachments)
        ? this.form.attachments
        : [];

      const attachment = attachments.find(
        (a) => a && a.subject === subject && a.type === type
      );

      if (!attachment || !attachment.file) return "";

      // Support both string and object responses for file
      if (typeof attachment.file === "string") return attachment.file;

      return attachment.file.originalname ||
        attachment.file.name ||
        attachment.file.filename ||
        "";
    },
  },
};
</script>
